const EVENT_ID='EVENT2024040308231833647861'
const EVALUATOR_ID='PAR2022060817103879325824'
const BELT_ID='BELT-1'
const ASSESMENT_ID='ASS-0201'
const URL_API = 'https://examjabar.teknologi40.com/api'

const StaticVar = {
  EVENT_ID,
  EVALUATOR_ID,
  BELT_ID,
  ASSESMENT_ID,
  URL_API
};

export default StaticVar;